import { createContext } from 'react';

import { ApiClient } from '../ApiClient';

export const ApiContext = createContext<ApiClient | undefined>(undefined);

export const ApiProvider = ApiContext.Provider;
